import { Component } from '@angular/core';

import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
  selector: 'app-icon-cell-renderer',
  templateUrl: './icon-cell-renderer.component.html',
  styleUrls: ['./icon-cell-renderer.component.scss']
})
export class IconCellRendererComponent implements ICellRendererAngularComp {
  params: {
    icon?: string;
    svgIcon?: string;
    description?: string;
    displayName?: string;
    iconStyle: any;
    iconClass: any;
  } = {
    iconStyle: {},
    iconClass: {}
  };

  agInit(params: ICellRendererParams): void {
    this.params = params.value;
    if (params.colDef.tooltipComponent) {
      delete this.params.description;
    }
  }

  refresh(params) {
    return true;
  }

}
